<script lang="ts">
	import { onMount } from 'svelte';
	import { resolveContent } from "$lib/content/registry";
	import { track } from "$lib/analytics";
	import type { PageData } from './$types';

	let { data }: { data: PageData } = $props();

	// Use the content registry to resolve landing page content
	const Component = resolveContent('landing', data.brand);

	// Track funnel start event
	onMount(() => {
		track("FunnelStart");
	});
</script>

<svelte:head>
	<title>Get Started - {data.config.displayName}</title>
	<meta name="description" content="Join {data.config.displayName} and start your journey with {data.config.productName}." />
	<meta property="og:title" content="Get Started - {data.config.displayName}" />
	<meta property="og:type" content="website" />
</svelte:head>

<div class="landing-hero">
	<div class="landing-content">
		{#if Component}
			<svelte:component this={Component} data={data} />
		{:else}
			<div class="error-container">
				<h1>Content Not Found</h1>
				<p>The landing page content could not be loaded.</p>
			</div>
		{/if}
	</div>
</div>

<style>
	.landing-hero {
		background: linear-gradient(135deg, var(--brand-primary), var(--brand-secondary));
		color: white;
		padding: 4rem 2rem;
		min-height: 80vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.landing-content {
		max-width: 600px;
		margin: 0 auto;
		text-align: center;
	}

	.landing-content :global(h1) {
		font-size: 3rem;
		font-weight: 700;
		margin-bottom: 1.5rem;
		line-height: 1.2;
	}

	.landing-content :global(p) {
		font-size: 1.25rem;
		margin-bottom: 3rem;
		opacity: 0.9;
		line-height: 1.6;
	}

	@media (max-width: 768px) {
		.landing-content :global(h1) {
			font-size: 2.5rem;
		}

		.landing-content :global(p) {
			font-size: 1.1rem;
		}
	}

	.error-container {
		text-align: center;
		padding: 4rem 2rem;
		color: white;
	}
</style>
